exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.expandable-section,.expandable-subsection{position:relative}.expandable-section .tooltip,.expandable-subsection .tooltip{position:relative;background:rgba(0,0,0,.7);color:#fff;visibility:hidden;padding:5px;border-radius:5px}.expandable-section.hovered,.expandable-subsection.hovered{background-color:#5b5b5b}.expandable-section__content,.expandable-subsection__content{display:block;transition:max-height .3s ease-out;overflow:hidden;text-overflow:ellipsis;max-height:0;width:100%}.expandable-section__name,.expandable-subsection__name{font-family:Open Sans,sans-serif;font-size:14px;font-weight:600;color:#2c2c2c;display:inline-block;margin:16px 24px;text-transform:uppercase;box-sizing:border-box}.expandable-section_break,.expandable-subsection_break{height:2px;margin:0;margin-top:-3px;border:0;border-top:2px solid #8b8b8b}.expandable-section__icon,.expandable-subsection__icon{cursor:pointer;position:absolute}.expandable-section__icon--right,.expandable-subsection__icon--right{right:24px;top:18px;width:16px;height:16px}.expandable-section__icon--left,.expandable-subsection__icon--left{top:6px;left:16px;width:8px;height:8px}.expandable-section--expanded .expandable-section__content,.expandable-subsection--expanded .expandable-subsection__content{max-height:2000px;transition:max-height 1s ease-in}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ExpandableSectionSettings/ExpandableSection.scss
// module id = 1558
// module chunks = 0